export const MENU_CLOSE_TIMEOUT = 500 // ms
export const NAVBAR_MENU_PORTAL_ID = 'navbar-menu-portal'
export const NOTIFICATION_COUNT_REFETCH_INTERVAL = 12000 // ms
